import React, { FC } from 'react';
import { observer } from 'mobx-react';
import { Menu } from 'antd';
import { Catcher, getMenuMode } from '../';
import { getParenIdOfChildren } from '../../Pages/pagesBooks/childrenOfParents';
import { IMainMenuProps, makeMenuItems } from './menuTools';
import { MenuInfo } from 'rc-menu/lib/interface';
import {
    usePagesStoreCurrentComponent,
    usePagesStoreMenu,
    useProfile,
    useRouterStore,
    useUiLanguage,
} from '../../hooks';
import { authLogOutUser } from '../../middleware';

export const MenuMain: FC<IMainMenuProps> = observer(({ onChangeCollapse, collapsed, menuType }) => {
    const routerStore = useRouterStore();
    const menu = usePagesStoreMenu();
    const { firstName, lastName } = useProfile();
    const { routeName } = usePagesStoreCurrentComponent();
    const parentComponentId = getParenIdOfChildren(routeName);
    const selectKeys = parentComponentId ? [parentComponentId] : [];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const languageId = useUiLanguage();

    const goToComponentKey = (key: string): void => {
        if (typeof key !== 'undefined') {
            switch (key) {
                case 'collapse':
                    onChangeCollapse && onChangeCollapse();
                    break;
                case 'logOut':
                    authLogOutUser().then();
                    break;
                default:
                    break;
            }
        }
    };

    return (
        <Catcher>
            <Menu
                onClick={(e: MenuInfo): void => goToComponentKey(e.key.toString())}
                selectedKeys={selectKeys}
                mode={getMenuMode(menuType)}
                items={makeMenuItems({
                    menu: menu,
                    profileLabel: `${firstName} ${lastName}`,
                    type: menuType,
                    routerStore,
                    selectKeys,
                    collapsed,
                    onChangeCollapse,
                })}
            />
        </Catcher>
    );
});
